export const TEMPLATE_TYPE = Object.freeze({
  SVG: "SVG",
  LEGACY: "Legacy",
  HTML: "HTML",
});

const normalize = (value) =>
  String(value ?? "")
    .trim()
    .toLowerCase();

export const isSvgTemplate = (value) =>
  normalize(value) === TEMPLATE_TYPE.SVG.toLowerCase();

export const isLegacyTemplate = (value) =>
  normalize(value) === TEMPLATE_TYPE.LEGACY.toLowerCase();

export const isHtmlTemplate = (value) =>
  normalize(value) === TEMPLATE_TYPE.HTML.toLowerCase();

export const isHtmlUrl = (url) =>
  /\.html?(?:[?#]|$)/i.test(String(url ?? "").trim());

export function resolveTemplateSource(data) {
  const html = data?.template_html || data?.html_url || "";
  const url = html || data?.template_svg || "";
  const isHtml =
    Boolean(html) || isHtmlTemplate(data?.template_type) || isHtmlUrl(url);
  return {
    url,
    templateType: isHtml ? TEMPLATE_TYPE.HTML : data?.template_type,
  };
}
